import { render, staticRenderFns } from "./PromotionTooltip.vue?vue&type=template&id=37508afa&scoped=true&"
import script from "./PromotionTooltip.vue?vue&type=script&lang=js&"
export * from "./PromotionTooltip.vue?vue&type=script&lang=js&"
import style0 from "./PromotionTooltip.vue?vue&type=style&index=0&id=37508afa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37508afa",
  null
  
)

export default component.exports